import React, { useEffect, useRef } from "react";
import { ErrorMessage, useFormikContext } from "formik";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";

function TimeComponent(props: any) {
  const { name, label, ...rest } = props;
  const { setFieldTouched, isSubmitting, setFieldValue } = useFormikContext();
  const calendarRef = useRef<Calendar>(null);

  useEffect(() => {
    if (typeof rest.value === "string") {
      const localDate = new Date(rest.value);
      const today = new Date();
      today.setHours(localDate.getHours(), localDate.getMinutes());
      today.keepTime = true;
      setFieldValue(name, today);
    }
  }, [rest.value]);

  useEffect(() => {
    if (!isSubmitting) return;
    setFieldTouched(name, true, true);
  }, [isSubmitting]);

  const footerTamplete = () => {
    return (
      <div>
        <Button label="Close" onClick={closeCalendar} className="p-button-text" />
      </div>
    );
  };

  const closeCalendar = () => {
    if (calendarRef.current) {
      calendarRef.current.hide();
    }
  };

  return (
    <div className="py-2">
      {label && (
        <label htmlFor={name} className={rest.isRequired ? "isRequired" : ""}>
          {" "}
          {label}
        </label>
      )}
      <Calendar
        alt={name}
        name={name}
        {...rest}
        timeOnly
        dateFormat="hh:mm"
        hourFormat="12"
        onChange={(e: any) => {
          if (e.value != null) {
            const date = new Date(e.value);
            date.keepTime = true;
            setFieldValue(name, date);
          } else {
            setFieldValue(name, null);
          }
        }}
        footerTemplate={footerTamplete}
        ref={calendarRef}
      />
      <ErrorMessage name={name} render={(msg) => <div className="error">{msg}</div>} />
    </div>
  );
}
export default TimeComponent;
